/* eslint-disable @typescript-eslint/no-explicit-any */
import { DatePicker } from 'antd';
import 'antd/dist/antd.min.css';
import moment from 'moment';
import './custom.css';

function disabledDate(current: any) {
  const dateNow = new Date();
  const eighteenYearsAgo = dateNow.setFullYear(dateNow.getFullYear() - 18);
  return current && current > moment(new Date(eighteenYearsAgo), 'YYYY-MM-DD');
}

const DateInput = ({ onChange, disable, value, placeholder, req, className, labelStyles }: any) => {
  return (
    <div className='flex flex-col '>
      <label className={['text-[13px] font-poppins flex', labelStyles].join(' ')}>
        Date of birth
        {req && <span className='text-[red] ml-2'>*</span>}
      </label>
      <DatePicker
        onChange={(e) => onChange(e)}
        value={value ? moment(value) : null}
        disabled={disable}
        className={['h-[52px]', className, disable && '!bg-[#F0F6FE] !text-[red]'].join(' ')}
        placeholder={placeholder ?? 'Select date'}
        allowClear={false}
        disabledDate={disabledDate}
        style={{ color: 'red' }}
        // suffixIcon={<div></div>}
      />
    </div>
  );
};

export default DateInput;
